export default function valueOrDefault(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}